import { practicesOptions, procoDocsDocumentTypesOptions } from "./systemData"
import { calculableProcoDocuments } from "./docs"

export const procoDocsFunctions = {
    isDocumentNotViewed: (document) => {
        if (document) {
            
            if (document.source == "Law Firm") {
                return !document.is_viewed
            }
        }
        return false
    },
    isHIPPAOrLORUploaded: (practiceId, allProcodocsDocuments) => {
        let procodoscsDocsTypes = procoDocsDocumentTypesOptions()
        let practices = practicesOptions()
        const activeDocuments = calculableProcoDocuments(allProcodocsDocuments)
        
        if (procodoscsDocsTypes && activeDocuments.length > 0 && practices) {
            let practice = practices.find(item => item.value === practiceId)
    
            let docType = procodoscsDocsTypes.find(item => item.label == "HIPAA")
            let docTypeLOR = procodoscsDocsTypes.find(item => item.label == "LOR")

            if (practice && !practice.requires_hippa) { // if the practice does not require HIPAA, return true
                return true // we do not need to check for HIPAA documents in this practice
            }

            if (docTypeLOR) {
                let docLOR = activeDocuments.find(item => item.procodocs_document_type_id === docTypeLOR.value && (item.practices.includes(practice?.value?.toString()) || item.practices.includes('all')))
                if (docLOR) {
                    return true
                }
            }
            
            if (docType) {               

                let docHIPPA = activeDocuments.find(item => item.procodocs_document_type_id === docType.value && (item.practices.includes(practice?.value?.toString()) || item.practices.includes('all')))
                if (docHIPPA) {
                    return true
                }
            }
        }
        return false
    }
}